import { Controller } from "@hotwired/stimulus"
import { Dropdown } from "bootstrap"

// Preloads the actions dropdown turbo-frame on hover over the ellipsis button,
// and greys the button out when the loaded menu has no action.
export default class extends Controller {
  static values = {
    frameId: String,
    delay: { type: Number, default: 120 }
  }

  connect() {
    this.prefetchTimeout = null
    this.onFrameLoad = this.disableWhenEmpty.bind(this)
    this.element.addEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disconnect() {
    clearTimeout(this.prefetchTimeout)
    this.element.removeEventListener("turbo:frame-load", this.onFrameLoad)
  }

  disableWhenEmpty(event) {
    if (event.target.id !== this.frameIdValue) return
    if (event.target.querySelector("a, button, .dropdown-item")) return

    const toggle = this.element.querySelector('[data-bs-toggle="dropdown"]')
    if (!toggle) return

    Dropdown.getInstance(toggle)?.hide()
    toggle.disabled = true
    toggle.setAttribute("aria-disabled", "true")
  }

  prefetch() {
    if (this.shouldSkipPrefetch()) return

    clearTimeout(this.prefetchTimeout)
    this.prefetchTimeout = window.setTimeout(() => this.loadFrame(), this.delayValue)
  }

  shouldSkipPrefetch() {
    const connection = navigator.connection
    return Boolean(connection?.saveData || connection?.effectiveType === "2g")
  }

  loadFrame() {
    const frame = document.getElementById(this.frameIdValue)
    if (!frame || frame.hasAttribute("complete")) return

    const src = frame.getAttribute("src") || frame.dataset.src
    if (!src) return

    frame.loading = "eager"
    if (!frame.getAttribute("src")) frame.setAttribute("src", src)
    else frame.reload()
  }
}
